export default __webpack_public_path__ + "static/media/persona.c48cdae7.webp";